import Phaser from "phaser";
//import $ from 'jquery'
import {
  CST
} from "../../../CST";
import {
  Math
} from 'phaser';

export default class SimonSays extends Phaser.Scene {
  constructor() {
    super(CST.SCENES.SIMONSAYS);
  }

  init() {

  }

  preload() {}

  create() {
    //define an array to hold the random song
    this.songArray = [];
    //define the notes and sound effects
    const note1 = this.sound.add("note-1");
    const note2 = this.sound.add("note-2");
    const note3 = this.sound.add("note-3");
    const note4 = this.sound.add("note-4");
    this.bang = this.sound.add("bang");
    //play the notes on an array for easy indexing
    this.noteArray = [note1, note2, note3, note4];
    //lock the click for while the song is playing
    this.clickLock = true;
    //make the blocks
    var red = getBlock(0, this);
    var blue = getBlock(1, this);
    var yellow = getBlock(2, this);
    var green = getBlock(3, this);
    //
    //put the blocks in a group
    //this will make it easy to center all the blocks
    //
    this.blocks = this.add.group();
    this.blocks.add(red);
    this.blocks.add(blue);
    this.blocks.add(yellow);
    this.blocks.add(green);
    //
    //position the blocks
    //all the postions were set at 0
    //so we just need to set some of the positions
    //
    blue.x = 250;
    yellow.y = 250;
    green.y = 250;
    green.x = 250;
    //make the blocks 80% of the width of the screen
    this.blocks.width = this.width * 0.8;
    //scale the height to match the width
    this.blocks.scale.y = this.blocks.scale.x;
    //center the blocks on the screen
    this.blocks.x = this.width / 2 - this.blocks.width / 2;
    this.blocks.y = this.height / 2 - this.blocks.height / 2;
    //alpha the blocks
    resetBlocks();
    //add a note to the song
    addToSong();
    //play the song
    playSong();
  }

  update() {}
}

function getBlock(frame, self) {
  var block = self.add.image(0, 0, "squares");
  block.frame = frame;
  block.inputEnabled = true;
  block.events.onInputDown.add(self.clickBlock, this);
  return block;
}

function resetBlocks() {
  this.blocks.forEach(function (block) {
    block.alpha = 0.2;
  });
}

function addToSong() {
  var s = Math.random().integerInRange(0, 3);
  this.songArray.push(s);
}

function nextNote() {
  //alpha the blocks
  this.resetBlocks();
  //advance the playIndex
  //we start at -1 so the first time the playIndex will be 0
  this.playIndex++;
  //if the play index is equal to the songArray length then
  //song is over
  //
  if (this.playIndex == this.songArray.length) {
    this.clickLock = false;
    this.clickIndex = 0;
    this.time.events.remove(this.songTimer);
    return;
  }
  //get the number of the note from the song
  var note = this.songArray[this.playIndex];
  //play the note
  this.playNote(note);
}

function playSong() {
  //set the playIndex to negative one
  this.playIndex = -1;
  //start the timer to play the notes
  this.songTimer = this.time.events.loop(Phaser.Timer.SECOND, this.nextNote, this);
}

function playNote(note) {
  //get the sound object from the note array
  var sound = this.noteArray[note];
  sound.play();
  //get the block that goes with the sound
  var block = this.blocks.getChildAt(note);
  //light it up!
  block.alpha = 1;
  //turn off the lights after a 1/4 of a second delay
  this.time.events.add(Phaser.Timer.SECOND / 4, this.resetBlocks, this);
}

function clickBlock(target) {
  //if the song is playing return
  if (this.clickLock == true) {
    return;
  }
  //get the frame from the square clicked
  var index = target.frame;
  //if the index is equal to the number
  //in the songArray then the user
  //has pressed the right notes
  if (index == this.songArray[this.clickIndex]) {
    //get the note from the songArray
    var note = this.songArray[this.clickIndex];
    //play the note
    this.playNote(note);
    this.clickIndex++;
    //if the clickIndex is equal to the songArray length we have
    //reached the end of the song
    if (this.clickIndex == this.songArray.length) {
      this.clickLock = true;
      this.playIndex = -1;
      this.addToSong();
      this.playSong();
      return;
    }
  } else {
    //wrong note!
    //this Over
    this.bang.play();
    this.clickLock = true;
    this.scene.sendToBack();
    this.scene.resume(CST.SCENES.STORY_SELECT, 5);
    this.scene.stop();
  }
}